import { useContext, useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'
import { Divider, Alert, Text, Space, theme } from 'verak-ui'

import { isValidOccupancy } from '../commonUtils/SharedUtils'

import { CustomSelect } from '../basement/commonStyle'
import { renderLevels } from '../commonUtils/commonExports'
import { Context } from '../../../context/Provider'

import { nanoid } from 'nanoid'
import PrimaryOccupancySelector from '../../DraftRFQ/components/PrimaryOccupancySelector'

const WholeBasement = ({ onInputComplete, onDataComplete }) => {
	const [state] = useContext(Context)

	const { Type } = state.location || {}
	const { Level: floorNum, PrimaryOccupancy } =
		(Type === 'PROPERTYBASEMENT' ? state.location?.property : state.location) || {}

	const [Occupancy, setOccupancy] = useState(PrimaryOccupancy?.SubCategory || '')
	const [Level, setLevel] = useState(floorNum || '')

	const validateInput = () => {
		return !!Level && !!isValidOccupancy(Occupancy)
	}

	useEffect(() => {
		const val = validateInput()
		onInputComplete(val)
		if (val) {
			onDataComplete({
				levels: [
					{
						Level: Level,
						ID: nanoid(),
						PrimaryOccupancy: {
							SubCategory: Occupancy,
						},
					},
				],
			})
		}
	}, [Occupancy, Level]) // eslint-disable-line

	return (
		<>
			<Divider top="2rem" bottom="2rem" />
			<Text style={{ fontWeight: 700 }} fontSize="24px" mobileFontSize="14px">
				Please select the primary use of this risk location
				<span style={{ color: theme.colors.red }}>*</span>
			</Text>
			<Space y={2} />

			<div className="row">
				<PrimaryOccupancySelector
					value={Occupancy}
					isRiskLocationDetailsScreen
					riskLocationType="whole"
					onChange={(key, value) => {
						setOccupancy(value.SubCategory)
					}}
				/>
			</div>

			<Space y={1} />
			<Container>
				<Alert
					bgColor={theme.colors.secondaryLightRed}
					iconName="infoIconOctagon"
					infoIconColor={theme.colors.red}
					titleColor={theme.colors.red}
					title="Note"
				>
					<Text
						color={theme.colors.red}
						style={{
							fontWeight: 'bold',
						}}
					>
						IF the client uses this floor for multiple purposes - please ONLY enter the primary use
						above.
						<br />
						You will be asked about “other usage” later in the journey - which is where the client
						can disclose other activities.
					</Text>
				</Alert>
			</Container>

			<Space y={1} />
			<Divider top="1rem" bottom="1rem" />

			<Text style={{ fontWeight: 700 }} fontSize="24px" mobileFontSize="14px">
				Number of floors in the building
				<span style={{ color: theme.colors.red }}>*</span>
			</Text>
			<Space y={1} />
			<CustomSelect
				value={Level}
				onChange={selected => setLevel(selected)}
				placeholder="1 to 100"
				style={{ marginLeft: '1rem' }}
			>
				{/* exclude "0" from the no. of levels dropdown */}
				{renderLevels('PROPERTY', false, ['0'])}
			</CustomSelect>
		</>
	)
}

export default WholeBasement
